<div *ngIf="!!pills" class="item-packet-pills" [ngClass]="{ 'flex-column': isVertical }">
    <item-packet-pill *ngFor="let pill of (pills ?? [])" 
        [pill]="pill"
        [showTitle]="showTitle">
    </item-packet-pill>
    <item-packet-pill *ngFor="let entry of (filteredUserEntries ?? [])" 
        [pill]="entry.Packet.Pill" 
        [status]="entry.OverallStatus" 
        [items]="entry.Items"
        [showTitle]="showTitle"
        [showStatusStamp]="true"
    ></item-packet-pill>
    <item-packet-pill *ngFor="let entry of (filteredEntries ?? [])" 
        [pill]="entry.Pill"
        [showTitle]="showTitle"
    ></item-packet-pill>
</div>

